import * as React from "react";
import {FC, useContext} from "react";
import {Button, Container, Text} from "@chakra-ui/react";
import {useMutation, useQuery} from "@apollo/client";
import {activateVersionMutation, versionsQuery} from "./versionQueries";
import {AppContext, AppContextI} from "../../components/context/ContextWrapper";
import moment from "moment";
import {Header, RowData, TableInternal} from "../../components/table/TableInternal";
import {Version} from "../../components/types";

type Props = {
    visible: boolean
}

export const DATE_FORMAT_DA = "D/M-YYYY HH:mm:ss";

export const Versioning: FC<Props> = () => {
    const appContext: AppContextI = useContext<AppContextI>(AppContext);

    const [activateVersion] = useMutation(activateVersionMutation);
    const {data, refetch} = useQuery(versionsQuery, {
        variables: {
            areaId: appContext.getArea()?.id
        }
    });

    const doActivateVersion = (id: string) => {
        console.log("Click.....")
        activateVersion({
            variables: {
                id: id,
                areaId: appContext.getArea()?.id
            }
        })
            .then(() => refetch());
    }

    const headers: Header[] = [{
        title: "Release date"
    }, {
        title: "Name"
    }, {
        title: "Release note"
    }, {
        title: "Active"
    }];

    let rowData: RowData[] = [];
    if (data) {
        rowData = data?.getVersions?.map((version: Version) => {
            if (version.publishedAt > 0) {
                return {
                    fields: [
                        {
                            data: moment(new Date(version.publishedAt)).format(DATE_FORMAT_DA)
                        },
                        {
                            data: version.name
                        },
                        {
                            data: version.releaseNote
                        },
                        {
                            data: version.isActive ? <Button
                                    size="xs"
                                    title="Active version"
                                    disabled={true}
                                    style={{backgroundColor: "green"}}
                                    variant='solid'
                                /> :
                                <Button
                                    size="xs"
                                    title="Activate this version"
                                    onClick={() => doActivateVersion(version.id)}
                                />
                        }
                    ]
                }
            } else {
                return {fields: []};
            }
        });
    }

    return <Container maxWidth={"full"} maxHeight={"full"} overscrollY={"contain"}
                      style={{overflowY: "auto", paddingTop: "8px", paddingBottom: "48px"}}>
        <Text fontWeight={"bold"} fontSize={"xl"}>Versions</Text>

        <TableInternal headers={headers} rows={rowData}/>
    </Container>
}